import React, { useMemo } from 'react';

import { withBemMod } from '@bem-react/core';
import { cnSelect, ISelectProps } from '@yandex-int/hr-components/Select';

import './Select_view_legal.css';
import { WithViewLegalProps } from "../../button/Button_view_legal";

export type SelectWithViewLegal = {
    view?: 'legal';
};
export interface ILegalSelectProps extends ISelectProps {
    iconLeft?: JSX.Element;
}

export const withViewLegal = withBemMod<SelectWithViewLegal, ILegalSelectProps>(
    cnSelect(),
    { view: 'legal' },
    (Select) =>
        ({ view, ...otherProps }) => {
            const renderTrigger = useMemo(() => {
                return (
                    buttonProps: WithViewLegalProps,
                    Button: React.ComponentType<WithViewLegalProps>,
                ) => {
                    const updatedButtonProps: any = {...buttonProps};
                    if (otherProps?.iconLeft) {
                        const buttonText = updatedButtonProps.children
                        const children = <div>
                            {otherProps?.iconLeft}
                            {buttonText}
                        </div>;
                        updatedButtonProps.children = children;
                    }
                    return <Button {...updatedButtonProps} view="legal" />;
                };
            }, [otherProps?.iconLeft]);
            return <Select renderTrigger={renderTrigger} {...otherProps} />;
        },
);
